import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import cn from 'classnames';
import React, { forwardRef, MutableRefObject } from 'react';

import s from './OfferingSearch.module.scss';

interface IOfferingSearchInput {
  searchTerm?: string;
  minimal?: boolean;
  searchButton?: boolean;
  cancelButton?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
  onSearchClick?: () => void;
  onCancelClick?: () => void;
  isFocused?: boolean;
  showRecent?: boolean;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onMouseDown?: (value: boolean) => void;
  onKeyDown?: (value: React.KeyboardEvent<HTMLInputElement>) => void;
  onSubmit?: (value?: string, type?: string) => void;
}

const OfferingSearchInput = forwardRef((props: IOfferingSearchInput, ref) => {
  const {
    searchTerm,
    minimal,
    searchButton,
    cancelButton,
    placeholder,
    onSearchClick,
    onCancelClick,
    onFocus,
    onBlur,
    onChange,
    isFocused,
    onMouseDown,
    showRecent,
    onKeyDown,
    onSubmit
  } = props;

  return (
    <div className={cn(s.OfferingSearch__searchFieldWrapper, { minimal })}>
      <input
        ref={ref as MutableRefObject<HTMLInputElement>}
        type="search"
        // id="search"
        autoComplete="off"
        aria-autocomplete="none"
        maxLength={30}
        autoFocus={isFocused}
        onFocus={onFocus}
        onBlur={onBlur}
        value={searchTerm}
        className={cn(s.OfferingSearch__searchField)}
        placeholder={placeholder}
        onChange={({ target: { value } }) => onChange(value)}
        onMouseDown={() => isFocused && onMouseDown && onMouseDown(!showRecent)}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => onKeyDown && onKeyDown(event)}
        onSubmit={() => onSubmit && onSubmit(searchTerm, 'submit')}
      />
      {(searchButton || cancelButton) && (
        <span className={s.OfferingSearch__searchFieldControls}>
          {cancelButton && searchTerm && (
            <button
              onClick={onCancelClick}
              className={s.OfferingSearch__searchFieldControl}
              aria-label="Cancel"
            >
              <CancelIcon sx={{ fontSize: '18px', color: 'text.disabled' }} />
            </button>
          )}
          {searchButton && (
            <button
              onClick={onSearchClick}
              className={s.OfferingSearch__searchFieldControl}
              aria-label="Search"
            >
              <SearchIcon sx={{ fontSize: '22px', color: 'text.disabled' }} />
            </button>
          )}
        </span>
      )}
    </div>
  );
});

export default OfferingSearchInput;
